<template>
  <div>
    <HistoriaFrenkel :selectedLang="selectedLang" />
    <FoundersSlides :selectedLang="selectedLang" />
    <TeamSlides :selectedLang="selectedLang" />
    <PartnersCertificates :selectedLang="selectedLang" />
    <SiteFooter :selectedLang="selectedLang" />
  </div>
</template>

<script>
import { useSEO } from '@/composables/useSEO';
import HistoriaFrenkel from '@/components/HistoriaFrenkel.vue'
import FoundersSlides from '@/components/FoundersSlides.vue'
import TeamSlides from '@/components/TeamSlides.vue'
import PartnersCertificates from '@/components/PartnersCertificates.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  name: 'NosotrosPage',
  props: {
    selectedLang: {
      type: String,
      required: true
    }
  },
  components: {
    HistoriaFrenkel,
    FoundersSlides,
    TeamSlides,
    PartnersCertificates,
    SiteFooter
  },
  setup() {
    useSEO({
      title: 'Nosotros',
      description: 'Conoce al equipo detrás de Frenkel Engineering: expertos en Industria 4.0, automatización industrial y transformación digital con presencia internacional.',
      path: '/nosotros',
    });
  }
}
</script>
